import React, { useEffect, useState } from 'react'
import cx from 'classnames'
import { useSelector } from 'react-redux'
import Grid from '@material-ui/core/Grid'
import IconButton from '@material-ui/core/IconButton'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import Hidden from '@material-ui/core/Hidden'
import Fade from '@material-ui/core/Fade'
import url from 'front-end-core/core/url'
import MenuItemContainer from 'redux/containers/components/dealwatch/MenuItemContainer'
import selectWindowWidth from 'redux/selectors/selectWindowWidth'
import { MW_LIST_DEALS, MW_ANALYTICS } from 'constants/controllers'
import selectAolName from 'redux/selectors/selectAolName'

const menuItems = [
  { title: 'All Deals', dealType: 'all', label: 'all' },
  { title: 'Public M&A', dealType: 'pma', label: 'pma' },
  { title: 'IPOs', dealType: 'ipo', label: 'ipo' },
  { title: 'Secondary Offers', dealType: 'so', label: 'so' },
  { title: 'Analytics', label: 'analytics' }
]

const getUrl = ({ aol, dealType, searchPhrase }, search) => dealType || search
  ? url(MW_LIST_DEALS, { aol, dealType }, { q: searchPhrase })
  : url(MW_ANALYTICS, { aol })

const DealWatchHeader = props => {
  const [show, setShow] = useState(true)
  const windowWidth = useSelector(selectWindowWidth)
  const aol = useSelector(selectAolName)

  useEffect(() => {
    if (windowWidth > 959) {
      setShow(true)
    }
  }, [setShow, windowWidth])

  return (
    <div className='layout-width-constraint pt6 pt6-t pt4-m pb2 pb0-t pb0-m'>
      <div
        className={cx('pb3 w-100 relative transition-all', {
          'h-100': show, h0: !show
        })}
        data-help-item='menu'
        data-help-position='bottom'
      >
        <Fade in={show} timeout={300}>
          <Grid container justify='center' spacing={1}>
            {menuItems.map((item, index) => {
              const { searchPhrase } = props
              const url = getUrl(
                { aol, searchPhrase, dealType: item.dealType },
                item.label !== 'analytics'
              )
              return (
                <Grid key={index} item xs={4} sm={4} md={2}>
                  <MenuItemContainer {...{ ...item, url }} />
                </Grid>
              )
            }
            )}
          </Grid>
        </Fade>
        <Hidden mdUp>
          <div className='absolute left8 flex w-100' style={{ bottom: '-1.5rem' }}>
            <IconButton
              size='small'
              className={cx('bg-white shadow-black-1 o-80', { 'o-70': !show })}
              onClick={() => setShow(!show)}
            >
              {show ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </IconButton>
          </div>
        </Hidden>
      </div>
    </div>
  )
}

export default DealWatchHeader
